import React from "react";

export const RefreshIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.34357 16.7663V15.025H5.47086L5.20232 14.7831C4.51176 14.0893 4.0069 13.3363 3.68773 12.5244C3.36857 11.7126 3.20898 10.885 3.20898 10.0417C3.20898 8.44682 3.69655 7.03293 4.67169 5.80002C5.64669 4.5671 6.90885 3.76286 8.45815 3.38731V5.36647C7.45482 5.69759 6.6451 6.2939 6.02898 7.15543C5.41287 8.01682 5.10482 8.9789 5.10482 10.0417C5.10482 10.6468 5.22037 11.237 5.45148 11.8123C5.6826 12.3876 6.04155 12.9219 6.52836 13.4152L6.69669 13.5838V11.6667H8.43815V16.7663H3.34357ZM11.5423 16.6127V14.6336C12.5457 14.3024 13.3554 13.7061 13.9715 12.8446C14.5876 11.9832 14.8957 11.0211 14.8957 9.95835C14.8957 9.35321 14.7801 8.763 14.549 8.18772C14.3179 7.61245 13.9589 7.07814 13.4721 6.58481L13.3038 6.41627V8.33335H11.5623V3.23376H16.6569V4.97502H14.5296L14.7982 5.21689C15.4887 5.91078 15.9936 6.6637 16.3127 7.47564C16.6319 8.28745 16.7915 9.11502 16.7915 9.95835C16.7915 11.5532 16.3039 12.9671 15.3288 14.2C14.3538 15.4329 13.0916 16.2372 11.5423 16.6127Z"
      fill="#4C4CF6"
    />
  </svg>
);
